// extracted by mini-css-extract-plugin
export default {"array-item":"arrayItem_array-item__8RIBt","item":"arrayItem_item__20Rh+","array":"arrayItem_array__hoDeW","remove-box":"arrayItem_remove-box__tB+ow","error":"arrayItem_error__fh+ia"};